import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionTagsComponent } from './question-tags.component';
import { QuestionTypeModule } from '../../../pipes/question-type';

@NgModule({
  imports: [CommonModule, QuestionTypeModule],
  declarations: [QuestionTagsComponent],
  exports: [QuestionTagsComponent, QuestionTypeModule]
})
export class QuestionTagsModule {}
